import { render, staticRenderFns } from "./OrderBasket.vue?vue&type=template&id=02846633&scoped=true"
import script from "./OrderBasket.vue?vue&type=script&lang=js"
export * from "./OrderBasket.vue?vue&type=script&lang=js"
import style0 from "./OrderBasket.vue?vue&type=style&index=0&id=02846633&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02846633",
  null
  
)

export default component.exports